import { render, staticRenderFns } from "./c-header.vue?vue&type=template&id=35415bd8"
import script from "./c-header.vue?vue&type=script&lang=js"
export * from "./c-header.vue?vue&type=script&lang=js"
import style0 from "./c-header.vue?vue&type=style&index=0&id=35415bd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports